<template>
  <div class="periodic-bubble">
    <div class="periodic-bubble__body">
      <template v-if="element === 'n'">
        N <br />
        <span class="periodic-name">Nitrogen</span>
      </template>
      <template v-if="element === 'p2o5'">
        P<sub>2</sub>O<sub>5</sub> <br />
        <span class="periodic-name">Phosphorus</span>
      </template>
      <template v-if="element === 'k2o'">
        K<sub>2</sub>O <br />
        <span class="periodic-name">Potassium</span>
      </template>
      <template v-if="element === 'mg'">
        Mg <br />
        <span class="periodic-name">Magnesium</span>
      </template>
      <template v-if="element === 's'">
        S <br />
        <span class="periodic-name">Sulfur</span>
      </template>
      <template v-if="element === 'zn'">
        Zn <br />
        <span class="periodic-name">Zinc</span>
      </template>
      <template v-if="element === 'b'">
        B <br />
        <span class="periodic-name">Boron</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    element: {
      type: String,
      required: true,
      validator: value =>
        ['n', 'p2o5', 'k2o', 'mg', 's', 'zn', 'b'].includes(value)
    }
  }
};
</script>

<style lang="scss" scoped>
.periodic-bubble {
  align-items: center;
  display: flex;
  font-family: $articulat-cf;
  height: 3rem;
  justify-content: center;
  margin: 0 spacing('xs');
  margin-bottom: spacing('xs');
  width: 3rem;

  &__body {
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    transform: translateY(0.08rem); // adjust for line height

    @include breakpoint('md') {
      font-size: 24px;
      font-weight: 500;
      line-height: 25px;
    }
    .periodic-name {
      display: none;
      font-family: $inter;

      @include breakpoint('md') {
        color: color('inactive-grey');
        display: block;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
      }
    }
  }
}
</style>
